
import { useParams } from 'react-router-dom';
import { MarcasFormState } from '../../../context/marcas/MarcasFormState';
import { Form } from './form';

export const MarcasFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Marca" : "Crear Marca";
  return (
    <MarcasFormState>
        <Form title={title} />
    </MarcasFormState>
  );
};
